// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"202":"de175923630ccf5f","521":"b766ef233d6cc968"}[chunkId] + ".js";
};